import { count } from "@wordpress/wordcount";

export default function (words) {
  if (words === null || words === undefined) {
    return 0;
  }

  const wordCountStrategy = "words";
  return count(words, wordCountStrategy);
}
